import React, { useState } from 'react';

const OrdersSearch = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchField, setSearchField] = useState('all'); // all, orderNumber, phone, email

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch({ term: searchTerm, field: searchField });
  };

  return (
    <form onSubmit={handleSearch} className="bg-white p-4 rounded-lg shadow mb-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-grow">
          <label htmlFor="search" className="sr-only">
            Rechercher
          </label>
          <div className="relative rounded-md shadow-sm">
            <input
              type="text"
              name="search"
              id="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-4 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder="Rechercher une commande..."
            />
            <div className="absolute inset-y-0 right-0 flex items-center">
              <select
                id="searchField"
                name="searchField"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
                className="h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
              >
                <option value="all">Tout</option>
                <option value="orderNumber">N° Commande</option>
                <option value="phone">Téléphone</option>
                <option value="email">Email</option>
              </select>
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Rechercher
        </button>
      </div>
    </form>
  );
};

export default OrdersSearch;
